import { svg } from '@/app/editor/sidebar/utils/actions.assets';

(function (jQuery) {
  jQuery.notifiBar = function (element, options) {
    const defaults = {
      msg: '',
      type: '',
      duration: 3000,
    };
    // type support     success | info | warning | error
    this.settings = {};
    const $element = jQuery(element);

    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
    };

    this.showNotifi = function (options) {
      this.settings = jQuery.extend({}, defaults, options);

      const duration = this.settings.duration;
      const zIndex = this.settings.zIndex;
      const icon = {
        success: svg('successCircleFilled'), 
        error: svg('errorCircleFilled'),
        info: svg('infoCircleFilled'),
        warning: svg('warningFilled'),
      };
      const template =  `
        <div class="notifi noti-${this.settings.type} notifi-top mb-1">
          <span>${this.settings.msg}</span>
          <a class="close-notifi" href="#">${svg('cancle')}</a>
        </div>
      `
      const $tmp = jQuery(template);
      if (this.settings.type && icon.hasOwnProperty(this.settings.type)) {
        $tmp.prepend(icon[this.settings.type]);
      }
      if (zIndex != null && zIndex != undefined) {
        $element.css('z-index', zIndex);
      }
      $element.show().prepend($tmp);
      setTimeout(function () {
        $tmp.removeClass('notifi-top');
      }, 200);
      setTimeout(function () {
        $tmp.fadeOut('1000', function () {
          if ($element.children().length == 1) {
            $element.fadeOut('1000');
          }
          $tmp.remove();
          $element.css('z-index', '');
        });
      }, duration);

      $tmp
        .children('.close-notifi')
        .off('click')
        .on('click', function () {
          $element.empty().hide();
          $element.css('z-index', '');
          return false;
        });
    };

    this.init();
  };

  jQuery.fn.notifiBar = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('notifibar')) {
        const plugin = new jQuery.notifiBar(this, options);
        jQuery(this).data('notifibar', plugin);
      }
    });
  };
})(jQuery);
